import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import ReactTooltip from 'react-tooltip';
import { useTranslation } from 'react-i18next';
const PaginationButton = ({ pageSelect, pagecount, updateSelectPage }) => {
    const { t } = useTranslation();
    /**
     * Checks if the pageSelect page is the first, second or third
     * @returns true if the previous conditions are true
     */
    const checkFirst = () => {
        return pageSelect === 1 || pageSelect === 2 || pageSelect === 3;
    };
    /**
     * Checks if pageSelect page is the last one, penultimate or antepenultimate
     * @returns true if the previous conditions are true
     */
    const checkLast = () => {
        return pageSelect === pagecount || pageSelect === pagecount - 1 || pageSelect === pagecount - 2;
    };
    /**
     * This will paint the current middle number
     * @returns the pageSelect number
     */
    const generateCurrentNum = () => {
        if (pageSelect <= 3) {
            return 3;
        }
        if (pageSelect >= pagecount - 2) {
            return pagecount - 2;
        }
        return pageSelect;
    };
    return (_jsxs(_Fragment, { children: [!(pageSelect === 1) && (_jsxs("button", Object.assign({ onClick: () => updateSelectPage(pageSelect - 2), className: "pagination__item pagination__item-icon", "data-tip": true, "data-for": "paginationTooltipLeft" }, { children: [_jsx(ReactTooltip, Object.assign({ id: "paginationTooltipLeft", place: "bottom", type: "info", effect: "solid" }, { children: t('Pagination.previousPage') }), void 0), _jsx("i", { className: "fas fa-chevron-left" }, void 0)] }), void 0)), _jsx("button", Object.assign({ onClick: () => updateSelectPage(0), className: `pagination__item ${pageSelect === 1 ? ' pagination__item--selected' : ''}` }, { children: 1 }), void 0), _jsx("button", Object.assign({ disabled: !checkFirst(), onClick: () => updateSelectPage(1), className: `pagination__item ${pageSelect === 2 ? 'pagination__item--selected' : ''}
          ${checkFirst() ? '' : 'button--disabled'}
              ` }, { children: checkFirst() ? 2 : '...' }), void 0), _jsx("button", Object.assign({ onClick: () => updateSelectPage(generateCurrentNum() - 1), className: `pagination__item ${pageSelect === generateCurrentNum() ? 'pagination__item--selected' : ''}` }, { children: generateCurrentNum() }), void 0), _jsx("button", Object.assign({ disabled: !checkLast(), onClick: () => updateSelectPage(pagecount - 2), className: `pagination__item ${pageSelect === pagecount - 1 ? ' pagination__item--selected' : ''}
          ${checkLast() ? '' : 'button--disabled'}
          ` }, { children: checkLast() ? pagecount - 1 : '...' }), void 0), _jsx("button", Object.assign({ onClick: () => updateSelectPage(pagecount - 1), className: `pagination__item 
          ${pageSelect === pagecount ? ' pagination__item--selected' : ''}
          ` }, { children: pagecount }), void 0), _jsxs("button", Object.assign({ onClick: () => updateSelectPage(pageSelect), className: "pagination__item pagination__item-icon", style: {
                    visibility: pageSelect === pagecount ? 'hidden' : 'visible',
                }, "data-tip": true, "data-for": "paginationTooltipRight" }, { children: [_jsx(ReactTooltip, Object.assign({ id: "paginationTooltipRight", place: "bottom", type: "info", effect: "solid" }, { children: t('Pagination.nextPage') }), void 0), _jsx("i", { className: "fas fa-chevron-right" }, void 0)] }), void 0)] }, void 0));
};
export default PaginationButton;
